import { InfoIcon } from '@/assets/icons/info-icons/info';
import { Banner } from '@/components/basicComponents/banner';
import Button from '@/components/basicComponents/button';
import { themeVar } from '@/styles/theme';
import { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
import { ColumnsSection } from '../../columnsSection';
import { DescriptionSection } from '../../descriptionSection';
import { ProgressBar } from '../../progressBar';
import { ButtonsControl, ImportWrapper } from '../../styles';
import { IColumnsSection, IDescriptionSection } from '../../types';
import { UploadFile } from '../../uploadFile';
import { allocationsSteps } from '../constants';

interface UploadDataFileProps {
  importSteps: typeof allocationsSteps;
  handleUploadFile: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onDropHandler: (e: React.DragEvent<HTMLDivElement>) => void;
  drag: boolean;
  setDrag: Dispatch<SetStateAction<boolean>>;
  file: File | null;
  handleClose: () => void;
  nextStep: () => void;
  loading: boolean;
  isValidFile: boolean;
  descriptionSection?: IDescriptionSection;
  columnsSection?: IColumnsSection;
  buttonLabels?: {
    cancel?: string;
    continue?: string;
  };
  downloadExistingData?: () => void;
  deleteFile?: () => void;
  errorMessage?: string;
}

export const UploadDataFile = ({
  importSteps,
  handleUploadFile,
  onDropHandler,
  drag,
  setDrag,
  file,
  handleClose,
  nextStep,
  loading,
  isValidFile,
  descriptionSection,
  columnsSection,
  buttonLabels,
  downloadExistingData,
  deleteFile,
  errorMessage
}: UploadDataFileProps) => {
  return (
    <ImportWrapper>
      <ProgressBar importSteps={importSteps} />
      <SectionsWrapper>
        {descriptionSection && <DescriptionSection {...descriptionSection} />}
        {columnsSection && <ColumnsSection columnsSection={columnsSection} downloadExistingData={downloadExistingData} />}
      </SectionsWrapper>
      <UploadFileText>Upload a file to get started</UploadFileText>
      <DropFileAreaWrap>
        {!isValidFile && (
          <Banner
            icon={<InfoIcon width={26} height={26} fill={themeVar('context.light')} />}
            title="Something went wrong"
            description={errorMessage}
            bgColor={themeVar('context.error')}
            color={themeVar('context.light')}
          />
        )}
        <UploadFile
          file={file}
          handleUploadFile={handleUploadFile}
          onDropHandler={onDropHandler}
          drag={drag}
          setDrag={setDrag}
          loading={loading}
          deleteFile={deleteFile}
        />
      </DropFileAreaWrap>
      <ButtonsControl>
        <Button styleType="outline" size="lg" onClick={handleClose}>
          {buttonLabels?.cancel || 'Cancel'}
        </Button>
        <Button size="lg" styleType={Boolean(!file || loading) ? 'disabled' : 'default'} onClick={nextStep}>
          {buttonLabels?.continue || 'Continue'}
        </Button>
      </ButtonsControl>
    </ImportWrapper>
  );
};

const SectionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const UploadFileText = styled.p`
  text-align: center;
  padding: 50px 0 10px 0;
  color: ${themeVar('font.weak')};
  font-family: Blinker;
  font-size: 16px;
  font-weight: 400;
  line-height: 22.4px;
`;

const DropFileAreaWrap = styled.div`
  margin-top: 65px;
`;
